<template>
    <div>
        <div class="columns">
            <div class="column is-6 is-offset-3">
                <admin-form :create="true" @saved="onSave"></admin-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {}
        },
        methods: {
            onSave() {
                this.$router.push({name: 'admins'})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// AdminCreate.vue?2efc7bc8